import {mapGetters, mapState} from "vuex";
import Swal from 'sweetalert2/dist/sweetalert2'
import {SAVE_SE_REQUEST} from "@/store/actions/se";

// imask Number mask options — identical to the currency mask used on the tax form
// pages (see BaseFormMixin.js) so amount fields look/behave the same everywhere
// (e.g. "Total Wages", "Rate of Pay", "Pay Increase Amount").
const currMaskType = {
  mask: '$num',
  blocks: {
    num: {
      mask: Number,
      scale: 2,
      thousandsSeparator: ',',
      radix: '.',
      signed: true,
      min: -999999999,
      max: 999999999,
    }
  }
};

// Mixin shared by the Wage Earner screens (SeWageEmployments, SeWageEmploymentDocs, SeWageIncomeDocument).
// Mirrors the navigation / save conventions of BaseFormMixin, but for the dynamic wageData tree
// instead of the fixed tax-form tableData grid.
export default {

  data() {
    return {
      isSavingWageData: false,
      currencyMask: currMaskType
    }
  },

  computed: {
    ...mapState({
      seRequest: state => state.se.request,
    }),
    ...mapGetters([
      'isLocked',
      'getWageEmployments',
      'getWageFormRoutes',
      'getWageEmploymentLabel',
      'getWageIncomeDocumentLabel'
    ]),

    // route params, coerced to Number
    employmentIdx() {
      return Number(this.$route.params.employmentIdx)
    },
    docIdx() {
      return this.$route.params.docIdx !== undefined ? Number(this.$route.params.docIdx) : undefined
    },

    currentEmployment() {
      return this.getWageEmployments[this.employmentIdx]?.employment
    },

    currentIncomeDocument() {
      return this.docIdx !== undefined ? this.currentEmployment?.incomeDocuments[this.docIdx] : undefined
    }
  },

  methods: {
    next() {
      this.saveRequest();
      let routes = this.getWageFormRoutes
      let ri = routes.indexOf(this.$route.path);
      if (ri !== -1 && ri < routes.length - 1) {
        this.$router.push(routes[ri + 1])
      } else {
        this.$router.push('/se-eval/eval-findings')
      }
    },

    previous() {
      let routes = this.getWageFormRoutes
      let ri = routes.indexOf(this.$route.path);
      if (ri > 0) {
        this.$router.push(routes[ri - 1])
      } else {
        this.$router.push('/se-eval/du-evaluation')
      }
    },

    async saveRequest() {
      try {
        await this.$store.dispatch(SAVE_SE_REQUEST);
      } catch (e) {
        await Swal.fire({
          title: `Could not save`,
          buttonsStyling: false,
          customClass: {confirmButton: 'bp-button bp-button--primary'},
          html: `<p>Could not save Income Calculator data</p>`
        })
      }
    },

    // Strip the "$" and "," formatting characters IMask leaves in the v-model value
    // (e.g. "$1,234.56") and return a plain number, or null if empty/invalid. Used by
    // all the currency-masked amount fields on the Wage Earner screens.
    parseCurrencyToNumber(v) {
      if (v === null || v === undefined || v === '') return null
      const n = Number(String(v).replace(/[^0-9.-]/g, ''))
      return isNaN(n) ? null : n
    },


    // Generic confirm-then-run helper used for all delete actions (employments, pay rates,
    // income documents, income items).
    confirmDelete(message, onConfirm) {
      Swal.fire({
        title: 'Are you sure?',
        html: message || 'This item will be permanently removed.',
        icon: 'warning',
        showCancelButton: true,
        buttonsStyling: false,
        customClass: {confirmButton: 'bp-button bp-button--primary', cancelButton: 'bp-button'},
        confirmButtonText: 'Delete',
        cancelButtonText: 'Cancel'
      }).then((result) => {
        if (result.isConfirmed) {
          onConfirm()
          this.saveRequest()
        }
      })
    }
  }
}


